import type { CategoryFilter, ProductFilterValue } from '@apiTypes';
import notEmpty from '../../../../core/util/notEmpty';
import preSortedAttributes from '../../../util/preSortedAttributes';

const getOptionsFromCategoryFilter = (
    values: string[],
    categoryFilter: CategoryFilter
) => {
    return values
        .map(item => {
            const index = categoryFilter.values.findIndex(
                fitlerValue => fitlerValue === item
            );
            const label = categoryFilter.valueLabels?.[index];
            if (label) {
                return {
                    label,
                    value: item,
                };
            }
        })
        .filter(notEmpty);
};

export const getFilterValues = ({
    fitlerValues,
    currentValue,
    categoryFilter,
    field,
}: {
    fitlerValues: ProductFilterValue[];
    currentValue: (string | undefined) | string[];
    categoryFilter?: CategoryFilter;
    field: string;
}) => {
    const options = fitlerValues
        .filter(notEmpty)
        .filter(value => value.value != '')
        .map(val => {
            return {
                label: val.valueLabel || val.value,
                value: val.value,
            };
        });

    if (categoryFilter) {
        if (Array.isArray(currentValue)) {
            const notIncludedItems = currentValue.filter(
                item =>
                    !fitlerValues.find(
                        possibleValue => possibleValue.value === item
                    )
            );
            if (notIncludedItems.length) {
                const notIncludedOptions = getOptionsFromCategoryFilter(
                    notIncludedItems,
                    categoryFilter
                );
                options.unshift(...notIncludedOptions);
            }
        } else if (currentValue) {
            const notIncluded = !options.find(
                item => item.value === currentValue
            );
            if (notIncluded) {
                const notIncludedOptions = getOptionsFromCategoryFilter(
                    [currentValue],
                    categoryFilter
                );
                options.unshift(...notIncludedOptions);
            }
        }
    }

    if (!preSortedAttributes.includes(field)) {
        options.sort((a, b) => {
            return a.label.localeCompare(b.label);
        });
    }

    return options;
};
